import { render, staticRenderFns } from "./RegisterSubject.vue?vue&type=template&id=6c487678"
import script from "./RegisterSubject.vue?vue&type=script&lang=js"
export * from "./RegisterSubject.vue?vue&type=script&lang=js"
import style0 from "./RegisterSubject.vue?vue&type=style&index=0&id=6c487678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports